import axios from "axios";
import { JsBridge } from "../utils/JsBridge"; // 从 index.tsx 导入 tokenPromise

const _baseUrl =
  window.location.host === "deerbook.cn"
    ? "https://api.deerbook.cn"
    : "https://test.deerbook.cn";
    

export const axiosInstance = axios.create({
  baseURL: _baseUrl,
});

//添加请求拦截器来动态设置 token，并确保等待 token
axiosInstance.interceptors.request.use(
  async function (config) {
    const userAgent = navigator.userAgent;
    const authMatch = userAgent.match(/Authorization_Bearer\s([^\s]+)/);
    if (authMatch && authMatch[1]) {
      const token = authMatch[1]; // 提取到的 Bearer Token

      console.log("token", `Bearer ${token}`);

      config.headers.authorization = `Bearer ${token}`; // 设置 authorization 头

      // config.headers.authorization = localStorage.getItem('token'); // 设置 authorization 头
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const _nativeDecrypt = (data: string) => {
  return new Promise((resolve) => {
    JsBridge.nativeDecrypt(data, (args: string) => {
      console.log('args', args);
      resolve(args);
    });
  });
};

axiosInstance.interceptors.response.use(
  async function (response) {
    // 生产解密
    if (window.location.hostname === 'deerbook.cn' && response?.data?.data) {
      const _decryptData = await _nativeDecrypt(response?.data?.data);
      response.data.data = _decryptData;
    }
    return response;
  },
  function (error) {
    console.error(error.response?.status, window.location.href);
    if (error.response?.status === 401) {
      JsBridge.gotoLogin({ sourceFrom: 'h5' });
    }
    return Promise.reject(error);
  }
);